<button attr.data-cy="{{checklistItem.attachment?.attachmentTitle}}" (click)="download()" *ngIf="checklistItem.attachment && checklistItem.attachment.attachmentId"
        [disabled]="disabled"
        class="link-button"
        mat-button
        matTooltip="{{checklistItem.attachment?.attachmentTitle}}">{{checklistItem.attachment?.attachmentTitle}}</button>
